import React from 'react';
import CartItem from '../components/CartItem';

const Cart = () => {
  return (
    <div>Cart</div>
  )
}

export default Cart